module.exports = __webpack_public_path__ + "media/images/next-bcd5ad47.svg";